var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0952148,
    y: 0.857178,
    width: 21.0476,
    height: 20.2381,
    fill: "url(#pattern11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_63_411",
    transform: "matrix(0.010016 0 0 0.0104167 0.0192308 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_63_411",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACv0lEQVR4nO2dPY9NURSGH81Fo1H6CJ1khij8BILEDyDRUOIfOL9gxGRGfHSjEo2CHp0oRDUUhAiFqCRmRiJxWXJlSzTD3fuevdeaue+TrPbm7PfZZ619T3EOCCGEEEIIIYQQQggxPgeBReAFsAbYJq+1tNYFYNZzo2wFbgI/AoRiTjVa+w1g4BH+4wABWJB61FrCrQCLtmB1vWXPn+a2Y+vUEJhpIWAxwGItaM23EPAywEItaC23ELAaYKEWtFZaCPBepAUvCUACNlTLeAd8AD6n+qo7gCphfwKWgLPA3vRncj22A7uBw8B5tSAmCn60uy+lUEsYne01AygL/z6wY8KpKAGUhX8Z2DJh+BJAWfi3ewheAigL/1nPTybVgsgTcLTH8CWAvPCf9hy+BJAn4JwE+NY+CfAL/3VB+IfSielNeizRx3VUx4LWg8x1HAO+VbiO6ljQWspcx6tK11EdC1pzGWvYVfE6qmNBq8tYwxEJ8BVwXAJ8BZyQAAkoxrvXm+4A/7BNLcg/cNMMiFVdRhvVEM4M90x6zv+v2p8hYOcYv/en7mZea3U8dvce/LgjAbgKeCIBuAr4KAG4CdgG/JQA3AQcKJhX1ZmmIXxSAnAVcEECcBVwRQJwFXBPAnAV8FwC+C3gPfD2P3UxI9hTY/zeqL5LAFUexp2ueGLblMdQkwAJMN0BqAWpBaEZYBrC/gPXdAryD9x0DI1VXcZRWv8DJKAc751uugP8wza1IP/ATTMgVnUZbVRDWALK8d7ppjvAP2xTC/IP3DQDYlU3LUM46otbuwACvjDFry7uAgho8urihQBhW1ABV2nAbHpVu3fgFkxAs9fXkz7b4R24BRNwjYYM0mc7vEO3IAIeenxHZpA+2zGcYgHDtPObh/83M+nLEcvOR9SukYDVtNb5lj1fCCGEEEIIIYQQQrDh+QVECyqwjA++igAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7089a4222e826315e0435d0acc822879.svg";
export { ForwardRef as ReactComponent };